import {FC} from "react";
import ChangePassword from "./ChangePassword";
import Header from "../SubComponents/Header";
import Footer from "../SubComponents/Footer";
import { Box } from "@material-ui/core";
import TakePicture from "./TakePicture";
import UploadFile from "./UploadFile";

const AllModal:FC = () => {
  return (
    <>
      <Header /> 
      <Box m={4}>
       <ChangePassword />
      </Box>
      <Box m={4}>
       <TakePicture />
      </Box>
      <Box m={4}>
       <UploadFile />
      </Box>
      <Footer />
    </>
  );
}

export default AllModal;
